import { memo, useMemo } from 'react';
import _get from 'lodash/get';
import _reverse from 'lodash/reverse';
import { IAppContextStore, useAppContext } from '../../../context/app-context';
import { filterItems } from '../../../helpers/contentful-helper';
import { CheckMarkIcon } from '../../icons';
import { Entry } from 'contentful';
import { IRequirementsSection } from './requirements-section.types';
import { RequirementFeaturedImage } from '.';

const RequirementsSection: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const requirementsSection: Entry<IRequirementsSection>[] = useMemo(() => (
    filterItems(rawContentFul, 'newHomepageRequirementsSection')
  ) as Entry<IRequirementsSection>[], [rawContentFul]);

  return (
    <>
      {
        _reverse(requirementsSection).map((content: Entry<IRequirementsSection>, index: number) => (
          <section key={index} id={_get(content, 'fields.elementId')} className='px-4 py-8 md:py-16'>
            <div className='max-w-6xl mx-auto w-full'>
              <div className={
                `relative flex md:flex-row gap-4 md:gap-6 md:mb-10 ${_get(content, 'fields.featuredImagePosition') === true ? 'flex-col' : 'flex-col-reverse'
                }`
              }>
                {/* If the featured Image Position is left */}
                {
                  _get(content, 'fields.featuredImagePosition') === true && (
                    <RequirementFeaturedImage
                      url={_get(content, 'fields.featuredImage.fields.file.url', '')}
                      title={_get(content, 'fields.featuredImage.fields.title', '')}
                    />
                  )
                }
                <div className='relative w-full max-w-[600px]'>
                  <h2 className='text-22 md:text-40 leading-30 md:leading-48
                      font-bold mb-6 font-inter text-center md:text-left'>
                    {_get(content, 'fields.title', '')}
                  </h2>
                  <div className='grid grid-cols-1 md:grid-cols-2 md:gap-4 mb-4'>
                    <div className='relative'>
                      {_get(content, 'fields.benefits.left').map((item: IRequirementsSection, bennefitsIndex: number) => (
                        <div key={bennefitsIndex} className='flex items-start gap-2 mb-3 md:mb-4'>
                          <CheckMarkIcon />
                          <div className='flex-1'>{item}</div>
                        </div>
                      ))}
                    </div>
                    <div className='relative'>
                      {_get(content, 'fields.benefits.right').map((item: IRequirementsSection, bennefitsIndex: number) => (
                        <div key={bennefitsIndex} className='flex items-start gap-2 mb-3 md:mb-4'>
                          <CheckMarkIcon />
                          <div className='flex-1'>{item}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <p className='max-w-lg text-16 leading-6 mb-4 font-sans'>
                    {_get(content, 'fields.description', '')}
                  </p>
                </div>
                {/* If the featured Image Position is right */}
                {
                  _get(content, 'fields.featuredImagePosition') === false && (
                    <RequirementFeaturedImage
                      url={_get(content, 'fields.featuredImage.fields.file.url', '')}
                      title={_get(content, 'fields.featuredImage.fields.title', '')}
                    />
                  )
                }
              </div>
              {
                (_get(content, 'fields.additionalInformation', '') || _get(content, 'fields.note', '')) && (
                  <>
                    <hr className='block md:hidden border-black mt-4 mb-7 max-w-[200px] mx-auto' />
                    <div className='max-w-3xl mx-auto w-full'>
                      <div className='text-16 leading-6 text-center mb-6'>
                        {
                          _get(content, 'fields.additionalInformation', [])
                        }
                      </div>
                      <div className='font-semibold text-16 leading-6 text-center'>
                        {
                          _get(content, 'fields.note', [])
                        }
                      </div>
                    </div>
                  </>
                )
              }
            </div>
          </section>
        ))
      }
    </>
  )
};

export default memo(RequirementsSection);
